import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

import {getChildSteps} from './StepLineageUtils';

export default function hasDownstreamFlagRowsStep(
  analysis: PipelineGraphQL,
  step: GetAnalysisPipelineStep
): boolean {
  const children = getChildSteps(analysis, step);

  if (children.some((childStep) => childStep.definition.stepType === PipelineStepType.FLAG_ROWS)) {
    return true;
  }

  for (const child of children) {
    if (hasDownstreamFlagRowsStep(analysis, child)) {
      return true;
    }
  }

  return false;
}
